<template>
  <base-section
    id="supporters"
  >
    <v-container
    id="container_supp"
    >
      <base-section-heading title="Hybrid Conference Supporters Opportunities">
      Position Your Company as a Leader in the Test Community! Become an official ETS 2023 Corporate Supporter and receive exclusive opportunities and prominent recognition throughout the conference, including the exclusive promotional opportunities in the table below. Please read more on the <a
      href="ETS23_Supporters_Plan.pdf"
      download
      >
      Supporters Plan document
      </a>, which provides full details about the benefits your company would obtain from becoming a supporter of ETS23.
      <br>
      <a
      href="ETS23_Supporters_Plan.pdf"
      download
      >
      <v-img
      src="supportersplan.png"
      >
      </v-img>
      </a>
      <br>
      <br>
      <v-btn
          href="ETS23_Supporters_Plan.pdf"
          rounded
          color="primary"
          dark
          download
          style="padding: 15px"
        >
          <v-icon
            left
            dark
          >
            mdi-download
          </v-icon>
          ETS23 – SUPPORTERS’ PLAN
          </v-btn>
        <br>
        <br>
      </base-section-heading>
      <base-section-heading title="Compare Supporters Benefits" />
      <v-simple-table
      fixed-header
      >
        <thead>
          <tr>
            <th />
            <th class="text-body-1 font-weight-bold text-center">
              PLATINUM
            </th>
            <th class="text-body-1 font-weight-bold text-center">
              GOLD
            </th>
            <th class="text-body-1 font-weight-bold text-center">
              SILVER
            </th>
            <th class="text-body-1 font-weight-bold text-center">
              BRONZE
            </th>
          </tr>
        </thead>

        <tbody class="text-body-1">
          <tr
            v-for="([name, one, two, three, four], i) in features"
            :key="i"
          >
            <td v-text="name" />

            <td class="text-center font-weight-bold">
              <template v-if="typeof one === 'boolean'">
                <v-icon :color="one ? 'success' : 'error'">
                  mdi-{{ one ? 'check' : 'close' }}
                </v-icon>
              </template>

              <template v-else>
                {{ one }}
              </template>
            </td>

            <td class="text-center font-weight-bold">
              <template v-if="typeof two === 'boolean'">
                <v-icon :color="two ? 'success' : 'error'">
                  mdi-{{ two ? 'check' : 'close' }}
                </v-icon>
              </template>

              <template v-else>
                {{ two }}
              </template>
            </td>

            <td class="text-center font-weight-bold">
              <template v-if="typeof three === 'boolean'">
                <v-icon :color="three ? 'success' : 'error'">
                  mdi-{{ three ? 'check' : 'close' }}
                </v-icon>
              </template>

              <template v-else>
                {{ three }}
              </template>
            </td>

            <td class="text-center font-weight-bold">
              <template v-if="typeof four === 'boolean'">
                <v-icon :color="four ? 'success' : 'error'">
                  mdi-{{ four ? 'check' : 'close' }}
                </v-icon>
              </template>

              <template v-else>
                {{ four }}
              </template>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
      <br>
      <br>
      <v-row>
          <base-info-col
          v-for="(type, i) in hybrid"
          :key=i
          :text="type.text"
          :title="type.title"
          :subtitle="type.subtitle"
          :features="type.features"
          />
      </v-row>
      <v-row>
          <base-info-col
          v-for="(type, i) in hybrid_second"
          :key=i
          :text="type.text"
          :title="type.title"
          :subtitle="type.subtitle"
          :features="type.features"
          />
      </v-row>
      <br>
      <br>
      <base-section-heading
      title="Contacts"
      >
      If you need any help or clarification please find the contacts below:
      <v-row>
        <v-col
          v-for="(suppcont, i) in supporterscontacts"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="suppcont"
            align="left"
            horizontal
          />
        </v-col>
      </v-row>
      </base-section-heading>
      <!---
      <br>
      <base-section-heading title="Virtual Conference Supporters" />
      <v-row>
          <base-info-col
          v-for="(type, i) in virtual"
          :key=i
          :text="type.text"
          :title="type.title"
          :subtitle="type.subtitle"
          :features="type.features"
          />
      </v-row>
      --->
      <br>

    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'Supporters',
    data: () => ({
      supporterscontacts: [
        {
          title: 'Paolo Bernardi',
          src: require('@/images/committees/paolobernardi.jpg'),
          text: 'Politecnico di Torino, IT, paolo.bernardi@polito.it',
        },
        {
          title: 'Bastien Deveautour',
          src: require('@/images/committees/bastien.jpg'),
          text: 'INL/CPE, FR, bastien.deveautour@cpe.fr',
        },
      ],
      features: [
        ['ETS23 MAIN SUPPORTER(S) diciture', true, false, false, false],
        ['The Social Event of the symposium will be announced “to be offered by the Main Supporter(s)”.', true, false, false, false],
        ['Additional publicity paths can be arranged as requested by the supporter in addition to all the following benefits.', true, false, false, false],
        ['A special area and/or Table Top Demo at the symposium site will be assigned to the supporter as its own demonstration area (posters, leaflets, recruitment material, and other advertisement material). This could be a table (provided by ETS) or a booth (supplied by the corporate supporter).', true, true, false, false],
        ['Slot assignment for Vendor Sessions.', 'GUARANTEED', 'HIGH PRIORITY', 'PRIORITY', false],
        ['Complimentary registrations to the symposium', '4', '2', '1', '1 DISCOUNTED'],
        ['Opportunity to send out  advertisement e-mails to registered symposium participants prior to the symposium.', '2', '2', '1', '1'],
        ['Supporter\'s name and logo will appear on the symposium’s website', 'MAIN BANNER + PRIMARY LEVEL + SUPPORTER PAGE', 'PRIMARY LEVEL + SUPPORTER PAGE', 'PRIMARY LEVEL + SUPPORTER PAGE', 'PRIMARY LEVEL + SUPPORTER PAGE'],
        ['Size of the logo in the supporters web page and on advertisement material including the newsletter', 'LARGE', 'MEDIUM-LARGE', 'MEDIUM-LARGE', 'MEDIUM'],
        ['Advertising space in the program booklet (PDF), the app, and screens at the event', 'FULL-PAGE', 'FULL-PAGE', 'HALF-PAGE', 'HALF-PAGE'],
        ['The Supporter\'s name and logo will appear in the proceedings of the symposium.', true, true, true, true],
        ['The Supporter\'s name and logo will appear on the symposium’s registration GADGET.', true, true, true, true],
        ['The Supporter will be allowed to provide branded giveaways for inclusion in the symposium registration gifts.', true, true, true, true],
        ['Exposure of company logo in a repeating presentation loop before, in-between, and after symposium sessions.', true, true, true, true],
      ],
      hybrid: [
        {
          title: 'PLATINUM',
          subtitle: '10.000€',
          features: [
            {
              text: 'ETS23 MAIN SUPPORTER(S) diciture',
            },
            {
              text: 'The Social Event of the symposium will be announced “to be offered by the Main Supporter(s)”.',
            },
            {
              text: 'Additional publicity paths can be arranged as requested by the supporter in addition to all the following benefits.',
            },
            {
              text: 'A special area and/or Table Top Demo at the symposium site will be assigned to the supporter as its own demonstration area (posters, leaflets, recruitment material, and other advertisement material). This could be a table (provided by ETS) or a booth (supplied by the corporate supporter).',
            },
            {
              text: 'Slot assignment for Vendor Sessions.',
            },
            {
              text: 'Complimentary registrations to the symposium',
            },
            {
              text: 'Opportunity to send out  advertisement e-mails to registered symposium participants prior to the symposium.',
            },
            {
              text: 'Supporter\'s name and logo will appear on the symposium’s website',
            },
            {
              text: 'Size of the logo in the supporters web page and on advertisement material including the newsletter',
            },
            {
              text: 'Advertising space in the program booklet (PDF), the app, and screens at the event',
            },
            {
              text: 'The Supporter\'s name and logo will appear in the proceedings of the symposium.',
            },
            {
              text: 'The Supporter\'s name and logo will appear on the symposium’s registration GADGET.',
            },
            {
              text: 'The Supporter will be allowed to provide branded giveaways for inclusion in the symposium registration gifts.',
            },
            {
              text: 'Exposure of company logo in a repeating presentation loop before, in-between, and after symposium sessions.',
            },
          ],
        },
        {
          title: 'GOLD',
          subtitle: '7.000€',
          features: [
            {
              text: 'A special area and/or Table Top Demo at the symposium site will be assigned to the supporter as its own demonstration area (posters, leaflets, recruitment material, and other advertisement material). This could be a table (provided by ETS) or a booth (supplied by the corporate supporter).',
            },
            {
              text: 'Slot assignment for Vendor Sessions.',
            },
            {
              text: 'Complimentary registrations to the symposium',
            },
            {
              text: 'Opportunity to send out  advertisement e-mails to registered symposium participants prior to the symposium.',
            },
            {
              text: 'Supporter\'s name and logo will appear on the symposium’s website',
            },
            {
              text: 'Size of the logo in the supporters web page and on advertisement material including the newsletter',
            },
            {
              text: 'Advertising space in the program booklet (PDF), the app, and screens at the event',
            },
            {
              text: 'The Supporter\'s name and logo will appear in the proceedings of the symposium.',
            },
            {
              text: 'The Supporter\'s name and logo will appear on the symposium’s registration GADGET.',
            },
            {
              text: 'The Supporter will be allowed to provide branded giveaways for inclusion in the symposium registration gifts.',
            },
            {
              text: 'Exposure of company logo in a repeating presentation loop before, in-between, and after symposium sessions.',
            },
          ],
        },
      ],
      hybrid_second: [
        {
          title: 'SILVER',
          subtitle: '5.000€',
          features: [
            {
              text: 'Slot assignment for Vendor Sessions.',
            },
            {
              text: 'Complimentary registrations to the symposium',
            },
            {
              text: 'Opportunity to send out  advertisement e-mails to registered symposium participants prior to the symposium.',
            },
            {
              text: 'Supporter\'s name and logo will appear on the symposium’s website',
            },
            {
              text: 'Size of the logo in the supporters web page and on advertisement material including the newsletter',
            },
            {
              text: 'Advertising space in the program booklet (PDF), the app, and screens at the event',
            },
            {
              text: 'The Supporter\'s name and logo will appear in the proceedings of the symposium.',
            },
            {
              text: 'The Supporter\'s name and logo will appear on the symposium’s registration GADGET.',
            },
            {
              text: 'The Supporter will be allowed to provide branded giveaways for inclusion in the symposium registration gifts.',
            },
            {
              text: 'Exposure of company logo in a repeating presentation loop before, in-between, and after symposium sessions.',
            },
          ],
        },
        {
          title: 'BRONZE',
          subtitle: '2.000€',
          features: [
            {
              text: 'Complimentary registrations to the symposium',
            },
            {
              text: 'Opportunity to send out  advertisement e-mails to registered symposium participants prior to the symposium.',
            },
            {
              text: 'Supporter\'s name and logo will appear on the symposium’s website',
            },
            {
              text: 'Size of the logo in the supporters web page and on advertisement material including the newsletter',
            },
            {
              text: 'Advertising space in the program booklet (PDF), the app, and screens at the event',
            },
            {
              text: 'The Supporter\'s name and logo will appear in the proceedings of the symposium.',
            },
            {
              text: 'The Supporter\'s name and logo will appear on the symposium’s registration GADGET.',
            },
            {
              text: 'The Supporter will be allowed to provide branded giveaways for inclusion in the symposium registration gifts.',
            },
            {
              text: 'Exposure of company logo in a repeating presentation loop before, in-between, and after symposium sessions.',
            },
          ],
        },
      ],
      virtual: [
        {
          title: 'Platinum Level',
          subtitle: '$5000',
          text: 'You can do ...',
          features: [
            {
              text: '3D Virtual booth',
            },
            {
              text: 'Premium booth graphic with brand customization',
            },
            {
              text: 'Private chat room function allowing audio and/or video calls with up to 50 people',
            },
          ],
        },
        {
          title: 'Gold Level',
          subtitle: '$3000',
          text: 'hey hey',
          features: [
            {
              text: '3D Virtual Booth',
            },
            {
              text: 'Booth graphic with brand customization',
            },
          ],
        },
        {
          title: 'Silver Level',
          subtitle: '$2000',
          text: 'hey hey',
          features: [
            {
              text: '3D Virtual Booth',
            },
            {
              text: '',
            },
          ],
        },
      ],
    }),
  }
</script>
